export default "__VITE_ASSET__1baf7d96__"